import React, { useState, useEffect, useRef } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { createUseStyles, useTheme } from "react-jss";
import classNames from "classnames";
import NotiserNavItem from "../NotiserNavItem";
import Icon from "../../../assets/icons/Icon";
import NavbarSearchbar from "./NavbarSearchbar";
import { useOnClickOutside } from "../../../utils/hookHelpers";
import HelpNavItem from "../HelpNavItem.js";
import SamverkanspartNavItem from "../Items/SamverkanspartNavItem";
import LogoffNavItem from "../LogoffNavItem";

const NavbarHeader = ({
  visibles,
  toggleSubmenu,
  logout,
  history,
  userState,
  changeSelectedSmvp,
}) => {
  const theme = useTheme()
  const classes = useStyles(theme);
  const ref = useRef();
  const [submenuVisible, setSubmenuVisible] = useState(false);
  const [datatype, setDatatype] = useState("light");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [navList, setNavList] = useState([
    {
      id: "settings",
      name: "Inställningar",
      icon: "settings2",
      to: "/min-sida",
    },
    {
      id: "logout",
      name: "Logga ut",
      icon: "logoff",
      to: "",
    },
  ]);
  useOnClickOutside(ref, () => setDropdownOpen(false));

  useEffect(() => {
    /* let dontShowAddKonto = userState.user.avdelnings.every(
      (x) => x.onlySkapaOrSkapaAndRegistrera || x.permission === 4
    ); */

    let dontShowAddKonto = userState.user.avdelnings.every(
      (x) => !x.internalUser
    );

    if (!dontShowAddKonto) {
      let tempNavList = [...navList];
      tempNavList.splice(0, 0, {
        id: "konton",
        name: "Konton",
        icon: "konton",
        to: "/kontohantering",
      });
      setNavList([...tempNavList]);
    }
  }, []);

  useEffect(() => {
    if (visibles) {
      setSubmenuVisible(visibles.some((x) => x === true));
    }
  }, [visibles]);

  useEffect(() => {
    if (submenuVisible) {
      setDatatype(submenuVisible ? "light" : "dark");
    }
  }, [submenuVisible]);

  const showTopmenu = userState.samverkansparts?.some(
    (element) => element.administrator || element.lokalbokare
  );
  const topMenu = showTopmenu && (
    <div className={classes.topRow}>
      {!userState.user.onlySamverkansparts && (
        <NavLink
          style={{
            textDecoration: !userState.selectedSamverkanspart
              ? "underline"
              : "none",
          }}
          onClick={() => {
            //Dispatch
            changeSelectedSmvp(null);
          }}
          data-tooltip-content="Mina arrangemang"
          data-tooltip-id="navright"
          data-tooltip-variant={datatype}
          to="/"
          className={classes.buttonTop}
        >
          <div>{userState.user.forbund.namn}</div>
        </NavLink>
      )}
      <SamverkanspartNavItem
        toggleSubmenu={toggleSubmenu}
        visible={visibles[5]}
        className={classes.buttonTop}
        datatype={datatype}
        noIcon={true}
        onlySamv={userState.user.onlySamverkansparts}
        text="Mina organisationer"
      />
    </div>
  );

  return (
    <nav className={classes.navbarHeader}>
      {topMenu}
      <div className={classes.mainRow}>
        <div className={classes.leftMenu}>
          <NavLink
            data-toggle="popover"
            onClick={toggleSubmenu}
            value="-1"
            data-tooltip-content="Hem"
            data-tooltip-id="navright"
            data-tooltip-variant={datatype}
            className={classes.button}
            to={!userState.selectedSamverkanspart ? "/" : "/samverkansparts"}
            exact
          >
            <div>
              <div className={classes.iconStyle}>
                <svg
                  width="20px"
                  height="17px"
                  fill="white"
                  viewBox="0 0 20 17"
                >
                  <path d="M8,17v-6h4v6h5V9h3L10,0L0,9h3v8H8z" />
                </svg>
              </div>
              <div>Hem</div>
            </div>
          </NavLink>
          {!userState.selectedSamverkanspart ? (
            <NavbarSearchbar />
          ) : (
            <h1 className={classes.logoTitle}>
              {userState.selectedSamverkanspart?.namn}
            </h1>
          )}
        </div>
        <div className={classes.centerMenu}></div>
        <div className={classes.rightMenu}>
          {!userState.selectedSamverkanspart ? (
            <>
              {/* {userState.samverkansparts?.length > 0 && (
                <SamverkanspartNavItem
                  toggleSubmenu={toggleSubmenu}
                  visible={visibles[5]}
                  className={classes.button}
                  datatype={datatype}
                />
              )} */}
              <NotiserNavItem
                toggleSubmenu={toggleSubmenu}
                visible={visibles[4]}
                className={classes.button}
              />
            </>
          ) : (
            <>
              {/*  <NavLink
                onClick={() => {
                  //Dispatch
                  changeSelectedSmvp(null);
                }}
                data-tooltip-content="Mina arrangemang"
                data-tooltip-id="navbottom"
                data-place="bottom"
                data-tooltip-variant={datatype}
                to="/"
                className={classNames(classes.button, classes.buttonLarge)}
              >
                <div>
                  <div className={classes.iconStyle}>
                    <GroupIcon size="24px" color="white" />
                  </div>
                  <div>Mina Arrangemang</div>
                </div>
              </NavLink>
              {userState.samverkansparts?.length > 1 && (
                <SamverkanspartNavItem
                  toggleSubmenu={toggleSubmenu}
                  visible={visibles[5]}
                  className={classes.button}
                  datatype={datatype}
                />
              )} */}
            </>
          )}
          <LogoffNavItem
            onClickButton={() => {
              logout();
            }}
          />

          <HelpNavItem />
          {/* <NotiserNavItem
          toggleSubmenu={toggleSubmenu}
          visible={visibles[4]}
          className={classes.button}
        />*/}
          <button
            onClick={() => {
              setDropdownOpen((v) => !v);
              toggleSubmenu();
            }}
            data-tooltip-id="bottom"
            data-place="bottom"
            data-tooltip-variant={datatype}
            ref={ref}
            className={classNames(
              classes.button,
              classes.dropdown_active,
              dropdownOpen && classes.dropdown_active_click
            )}
          >
            <li className={classes.dropdown}>
              <div className={classes.buttonContainer}>
                <div className={classes.iconStyle}>
                  <Icon type="settings" fill="white" width="18px" />
                </div>
                <div>{userState.user?.fornamn}</div>
              </div>
              <ul
                className={classNames(
                  classes.dropdown_menu,
                  showTopmenu && classes.dropdown_extended
                )}
              >
                {navList.map((x, i) => (
                  <li
                    key={i}
                    className={classes.dropdown_item}
                    style={{
                      animation:
                        "$sheet.keyframes.translateX 300ms " +
                        i * 60 +
                        "ms ease-in-out forwards",
                    }}
                    onClick={() =>
                      x.id === "logout" ? logout() : history.push(x.to)
                    }
                  >
                    <div className={classes.dropdown_item_container}>
                      <Icon type={x.icon} fill="white" width="18px" />
                      {x.name}
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          </button>
        </div>
      </div>
    </nav>
  );
};

const useStyles = createUseStyles( (theme) => ({
  navbarHeader: {
    display: "flex",
    position: "fixed",
    flexDirection: "column",
    top: "0",
    width: "100%",
    backgroundColor: theme.themColorDark,
    zIndex: "7",
    height: "auto",
  },
  logoTitle: {
    display: "flex",
    alignItems: "center",
    color: "white",
    textTransform: "initial",
    marginLeft: "20px",
  },
  topRow: {
    display: "flex",
    height: "30px",
    backgroundColor: theme.themeColorExtraDark,
    width: "100%",
  },
  mainRow: {
    display: "flex",
    height: "56px",
  },
  leftMenu: {
    display: "flex",
    marginLeft: "0",
    marginRight: "auto",
  },
  centerMenu: {
    margin: "0 auto",
  },
  rightMenu: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "0",
  },
  buttonTop: {
    marginLeft: "10px",
    border: "0",
    display: "flex",
    height: "100%",
    padding: "0",
    alignItems: "center",
    backgroundColor: "transparent",
    textAlign: "left",
    cursor: "pointer",
    color: "white",
    font: "500 11px Roboto",
    lineHeight: "unset",
    outline: "none",
    width: "auto",
  },
  button: {
    border: "0",
    display: "flex",
    height: "100%",
    padding: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    textAlign: "center",
    cursor: "pointer",
    color: "white",
    font: "500 11px Roboto",
    lineHeight: "unset",
    outline: "none",
    width: "64px",
    "& svg g polygon": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "& svg path, circle, rect": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "&:hover": {
      backgroundColor: theme.themeHoverDark,
      color: theme.themeHoverTextDarkColor,
    },
  },
  buttonLarge: {
    width: "77px",
    "& $iconStyle": {
      margin: "0",
    },
  },
  buttonContainer: {},
  active: {
    color: "white!important",
    background: theme.menuDarkColor + "!important",
  },
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "5px",
    marginTop: "3px",
  },
  dropdown: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    padding: "0px 5px 0px 5px",
    // position: "relative",
    // perspective: "1000px",
    zIndex: 100,
    "&:hover": {
      cursor: "pointer",
    },
  },
  dropdown_active: {
    minWidth: "64px",
    width: "unset",
    // "&:hover $dropdown_menu li": {
    //   display: "block",
    //   //marginRight: "18px",
    // },
  },
  dropdown_active_click: {
    "& $dropdown_menu li": {
      display: "block",
    },
  },
  dropdown_menu: {
    position: "absolute",
    top: "56px",
    right: "0px",
    perspective: "1000px",
    zIndex: "-1",
    "& li": {
      display: "none",
      color: "white",
      backgroundColor: theme.themColorDark,
      padding: "10px 20px",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: theme.themeHoverDark,
      },
      transformOrigin: "top center",
    },
  },
  dropdown_extended: {
    top: "85px",
  },
  dropdown_item_container: {
    display: "flex",
    borderBottom: "1px solid #b5b5b5",
    padding: "8px",
    "& svg": {
      marginRight: "10px",
    },
  },
  dropdown_item: {},
  "@keyframes translateX": {
    "0%": {
      opacity: "0",
      transform: "translateX(60px)",
    },
    "80%": {
      transform: "translateX(-5px)",
    },
    "100%": {
      opacity: "1",
      transform: "translateX(0px)",
    },
  },
}));
export default withRouter(NavbarHeader);
